import { OrderTypeEnum } from '@restavo/shared/enums/order';

export type OrderDraft = {
  itemCount: number;
  type?: OrderTypeEnum | null;
  tableId?: string | null;
  phoneNumber?: string | null;
  address?: string | null;
  /** False in the `/b/all` aggregate context, where no single branch is selected. */
  hasBranch: boolean;
  /** False until the restaurant currency is confirmed; amounts are rounded to its decimals. */
  currencyKnown: boolean;
};

/**
 * Whether the current POS draft may be submitted. Pure so the branch rule below is
 * testable without mounting the whole POS tree.
 *
 * `hasBranch` is the one that is not merely a UX nicety: `Orders.restaurantBranchId` is
 * NOT NULL, and the server persists the branch from the tenant context, which is null
 * under `/b/all`. Submitting from the aggregate view was a 500, not a validation error.
 */
export function canSubmitOrder(draft: OrderDraft): boolean {
  if (!draft.hasBranch || !draft.currencyKnown) {
    return false;
  }
  if (draft.itemCount === 0) {
    return false;
  }
  if (draft.type === OrderTypeEnum.TAKEAWAY) {
    return true;
  }
  if (draft.type === OrderTypeEnum.DINE_IN) {
    return Boolean(draft.tableId);
  }
  return draft.type === OrderTypeEnum.DELIVERY && Boolean(draft.phoneNumber) && Boolean(draft.address);
}
